import 'css-chunksrc/client/scenes/constraintEdition/startEndForm/styles.scss';export default {
  "form": "_form_3e54v_1"
};